var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",on:{"dragover":function($event){$event.stopPropagation();return $event.preventDefault()},"drop":function($event){$event.stopPropagation();return _vm.handleDrop.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }